import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KYMW7301Component } from './kymw7301.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { GetCouponService } from './api-services/get-coupon.service';
import { AddCouponService } from './api-services/add-coupon.service';
import { UpdateCouponService } from './api-services/update-coupon.service';
import { GetReceiptCatalogService } from './api-services/get-receipt-catalog.service';

/**
 * 注文単位値引クーポン登録画面 モジュール設定クラス
 *
 * @export KYMW7301Module
 * @class KYMW7301Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW7301Component,
  ],
  providers: [
    GetCouponService,
    AddCouponService,
    UpdateCouponService,
    GetReceiptCatalogService,
  ],
})
export class KYMW7301Module {

}
